import { render, staticRenderFns } from "./RuleChangeCompareDialog.vue?vue&type=template&id=8356aee6&scoped=true"
import script from "./RuleChangeCompareDialog.vue?vue&type=script&lang=js"
export * from "./RuleChangeCompareDialog.vue?vue&type=script&lang=js"
import style0 from "./RuleChangeCompareDialog.vue?vue&type=style&index=0&id=8356aee6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8356aee6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8356aee6')) {
      api.createRecord('8356aee6', component.options)
    } else {
      api.reload('8356aee6', component.options)
    }
    module.hot.accept("./RuleChangeCompareDialog.vue?vue&type=template&id=8356aee6&scoped=true", function () {
      api.rerender('8356aee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sorting/components/RuleChangeCompareDialog.vue"
export default component.exports